<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
    >
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <i class="fal fa-watch"></i>
        </span>
        <h3 class="kt-portlet__head-title">Response Times</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-actions">
          <template v-if="authenticated">
            <v-btn
              color="light-blue darken-3"
              class="ma-2 white--text"
              @click="exportGroupShop"
              text
              small
            >
              <v-icon right dark class="m-2"> fal fa-download </v-icon>
              Export
            </v-btn>
            <v-btn
              color="light-blue darken-3"
              class="ma-2 white--text"
              @click.stop="showReportModal = true"
              text
              small
            >
              <v-icon right dark class="m-2"> fal fa-paper-plane </v-icon>
              Send Report
            </v-btn>
          </template>
        </div>
      </div>
    </div>
    <div class="kt-portlet__body">
      <group-shop-send-report-modal v-model="showReportModal" />
      <v-card>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name of Dealer</th>
                <th class="text-center">First Email Response Time</th>
                <th v-if="isTrueCar" class="text-center">
                  Second Email Response Time
                </th>
                <th class="text-center">Call Response Time</th>
                <th class="text-center">SMS Response Time</th>
                <!--                <th class="text-center">Chat Response Time</th>-->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in internetShops" :key="item.id">
                <td>
                  <span v-if="item.is_dealer">
                    {{ item.specific_dealer.name }}</span
                  >
                  <span v-else>{{
                    hideDealerName ? `Local Competitor` : item.competitor.name
                  }}</span>
                </td>
                <td
                  class="text-center"
                  :class="
                    colorCodeResponseTime(
                      item.email_response_time,
                      'email',
                      index
                    )
                  "
                >
                  {{
                    item.email_response_time
                      ? item.email_response_time
                      : '-- : -- : --'
                  }}
                </td>
                <td
                  v-if="isTrueCar"
                  class="text-center"
                  :class="
                    colorCodeResponseTime(
                      item.email_second_response_time,
                      'email',
                      index
                    )
                  "
                >
                  {{
                    item.email_second_response_time
                      ? item.email_second_response_time
                      : '-- : -- : --'
                  }}
                </td>
                <td
                  class="text-center"
                  :class="
                    colorCodeResponseTime(
                      item.call_response_time,
                      'call',
                      index
                    )
                  "
                >
                  {{
                    item.call_response_time
                      ? item.call_response_time
                      : '-- : -- : --'
                  }}
                </td>
                <td
                  class="text-center"
                  :class="
                    colorCodeResponseTime(item.sms_response_time, 'sms', index)
                  "
                >
                  {{
                    item.sms_response_time
                      ? item.sms_response_time
                      : '-- : -- : --'
                  }}
                </td>
                <!--                <td class="text-center">-->
                <!--                  {{-->
                <!--                    item.chat_response_time-->
                <!--                      ? item.chat_response_time-->
                <!--                      : '-- : -- : --' -->
                <!--                  }}-->
                <!--                </td>-->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import GroupShopSendReportModal from '@/components/client-shops/group-shop/GroupShopSendReportModal.vue';
import { find as _find } from 'lodash-es';

export default {
  name: 'ResponseTime',

  props: {
    internetShops: {
      required: true,
      type: Array,
    },
    hideDealerName: {
      default: false,
    },
    isTrueCar: {
      default: false,
    },
  },

  components: {
    GroupShopSendReportModal,
  },

  computed: {
    authenticated() {
      return this.$auth.check();
    },
  },

  data() {
    return {
      showReportModal: false,
      downloadReportLoading: false,
    };
  },

  methods: {
    exportGroupShop() {
      this.downloadReportLoading = true;
      const { id } = this.$route.params;
      this.axios
        .get(`/secret-shop-management/export/group-shop/${id}`)
        .then(({ data }) => {
          window.open(data, '_blank');
          this.downloadReportLoading = false;
        })
        .catch(() => {
          this.downloadReportLoading = false;
        });
    },
    getDealerOption(key, index) {
      if (
        this.internetShops[index] &&
        undefined != this.internetShops[index].dealer.options &&
        undefined !=
          _find(this.internetShops[index].dealer.options, { name: key })
      ) {
        const option = _find(this.internetShops[index].dealer.options, {
          name: key,
        });
        return option.value;
      }

      return null;
    },
    parseResponseTimeToMinutes(val, index) {
      const responseTime = this.getDealerOption(val, index);
      if (null != responseTime) {
        if (!responseTime) {
          return false;
        }
        const formatted = responseTime.split(':');

        if (!formatted[0] || !formatted[1] || !formatted[2]) {
          return false;
        }

        const minutes =
          parseInt(formatted[0] * 60) +
          parseInt(formatted[1]) +
          parseInt(formatted[2] / 60);
        if (minutes <= 0) {
          return false;
        }

        return minutes;
      }

      return false;
    },
    colorCodeResponseTime(responseTime, type, index) {
      // for reference: https://prnt.sc/vbp8h7

      const yellowParsedResponseTime = this.parseResponseTimeToMinutes(
        `${type}_yellow_response_time`,
        index
      );
      const redParsedResponseTime = this.parseResponseTimeToMinutes(
        `${type}_red_response_time`,
        index
      );

      const yellow =
        false != yellowParsedResponseTime ? yellowParsedResponseTime : 5;
      const red = false != redParsedResponseTime ? redParsedResponseTime : 30;

      if (!responseTime) {
        return 'red-text';
      }

      const formatted = responseTime.split(':');

      if (!formatted[0] || !formatted[1] || !formatted[2]) {
        return 'red-text';
      }

      const minutes =
        parseInt(formatted[0] * 60) +
        parseInt(formatted[1]) +
        parseInt(formatted[2] / 60);

      if (minutes < 0) {
        return 'red-text';
      }

      if (minutes < yellow) {
        return 'green-text';
      }

      if (minutes >= yellow && minutes <= red) {
        return 'yellow-text';
      }

      if (minutes > red) {
        return 'red-text';
      }

      return 'red-text';
    },
  },
};
</script>

<style lang="stylus" scoped>
.kt-widget29__title
  font-family Oswald

.heading-result
  color #333

.kt-portlet.kt-portlet--solid-dark
  background #333 !important

.green-text
  color #43A047


.yellow-text
  color #F9A825


.red-text
  color #C62828
</style>
